module.exports = __webpack_public_path__ + "img/logo_agoria.5c405602.jpg";